export const environment = {
    production: true,
    baseUrl: 'https://dltusa-apim.azure-api.net/drs',
    codeApi: '5dac96b46c634402a43b769a95b4b0c7',
    mslConfig: {
        clientId: "cb44d8e2-36cd-474b-898d-da984e76fb82",
        authority: "https://login.microsoftonline.com/98a68466-6a9b-4cd8-af8a-e6540bf687cd",
        redirectUri: 'https://dltusafrontpressandgo.z21.web.core.windows.net'
    }
};
